__turbopack_context__.v({
  "body": "hero-stat-cards-module__uL5JKq__body",
  "card": "hero-stat-cards-module__uL5JKq__card",
  "heroStatFade": "hero-stat-cards-module__uL5JKq__heroStatFade",
  "list": "hero-stat-cards-module__uL5JKq__list",
  "loaded": "hero-stat-cards-module__uL5JKq__loaded",
  "skip": "hero-stat-cards-module__uL5JKq__skip",
  "title": "hero-stat-cards-module__uL5JKq__title",
  "titleLtr": "hero-stat-cards-module__uL5JKq__titleLtr",
});
